import { Button } from "@chakra-ui/react";
import React, { useState } from "react";
import PopupWrapper from "./PopupWrapper";
import layoutBg from "../assets/flipbook/LayoutBg.png";
import { getImageUrls } from "../utils/helpers";
import CroppedImageFromFile from "./formComponents/CroppedImage";
import ImgOptimized from "./ImgOptimized";
import LayoutSlide from "../pages/project-showcase/admin/Presentation/LayoutSlide";

const ViewLayoutBtn = ({
  floorMap,
  selection1,
  selection2,
  width = 1000,
  layout,
  index,
}) => {
  const [isPreview, setIsPreview] = useState(false);
  console.log({ layout, index });
  return (
    <>
      <Button
        disabled={!floorMap}
        onClick={() => setIsPreview(true)}
        colorScheme="teal"
        mt={2}
        w={"100%"}
      >
        Preview Layout Slide
      </Button>
      {isPreview && (
        <PopupWrapper
          // heading={"Layout slide preview"}
          width={
            "max-w-[1400px] aspect-[1.77/1] max-h-[95svh] overflow-hidden full-space-box  h-auto"
          }
          maxHeight="h-full"
          isWidthAuto={true}
          aspectRatio={"1.77/1 !important"}
          padding={0}
          // isHideHeading={true}
          onClose={() => setIsPreview(false)}
        >
          <LayoutSlide layout={layout} index={index} viewData={{}} />
        </PopupWrapper>
      )}
    </>
  );
};

export default ViewLayoutBtn;
